import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { AppProviders, createQueryClient } from "./lib/query";
import "./styles.css";

const queryClient = createQueryClient();

hydrateRoot(
  document.getElementById("root")!,
  <StrictMode>
    <AppProviders client={queryClient} dehydratedState={window.__REACT_QUERY_STATE__ as import("@tanstack/react-query").DehydratedState | undefined}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
);
